import { v4 as uuid } from 'uuid';
export var ValidatorDispatchActionType;
(function (ValidatorDispatchActionType) {
    ValidatorDispatchActionType["SET_INVALID_MESSAGE"] = "SetInvalidMessage";
    ValidatorDispatchActionType["CLEAR_REFRESH_ID"] = "ClearRefreshId";
    ValidatorDispatchActionType["TRIGGER_VALIDATION"] = "TriggerValidation";
    ValidatorDispatchActionType["CLEAR_ALL_ID"] = "ClearAllIds";
})(ValidatorDispatchActionType || (ValidatorDispatchActionType = {}));
export const validatorReducer = (state, { type, fieldId, invalidMessage }) => {
    const newState = state;
    switch (type) {
        case ValidatorDispatchActionType.SET_INVALID_MESSAGE:
            return fieldId
                ? Object.assign(Object.assign({}, state), { invalidMessages: Object.assign(Object.assign({}, state.invalidMessages), { [fieldId]: invalidMessage || null }) }) : state;
        case ValidatorDispatchActionType.TRIGGER_VALIDATION:
            return fieldId ? Object.assign(Object.assign({}, state), { refreshIds: Object.assign(Object.assign({}, state.refreshIds), { [fieldId]: uuid() }) }) : state;
        case ValidatorDispatchActionType.CLEAR_REFRESH_ID:
            return fieldId ? Object.assign(Object.assign({}, state), { refreshIds: Object.assign(Object.assign({}, state.refreshIds), { [fieldId]: '' }) }) : state;
        case ValidatorDispatchActionType.CLEAR_ALL_ID:
            // eslint-disable-next-line no-return-assign
            Object.keys(newState.refreshIds).forEach((key) => (newState.refreshIds[key] = ''));
            // eslint-disable-next-line no-return-assign
            Object.keys(newState.invalidMessages).forEach((key) => (newState.invalidMessages[key] = null));
            return Object.assign(Object.assign({}, state), newState);
        default:
            return state;
    }
};
